import { classNames } from "src/core/utilities/classNames";

interface Props {
    className?: string;
}

/** In place of a link's chevron or icon while its screen opens */
export const OpeningSpinner = ({ className }: Props) => (
    <span
        role="status"
        aria-label="Opening"
        className={classNames("opening-spinner loading loading-spinner", className)}
    />
);
